import React from "react";
import { ClickAwayListener, Stack, styled, Paper, Popper } from "@mui/material";
import { FIELD_TYPES } from "@hyro-components/fields/utils";
import MultipleOptionsContent from "@hyro-components/fields/multi-select/MultiSelectContent";
import FilterFieldList from "@hyro-components/hyro-filter/components/filter-field-list/FilterFieldList";
import FilterFieldText from "@hyro-components/hyro-filter/components/filter-field-text/FilterFieldText";
import FilterFieldDate from "@hyro-components/hyro-filter/components/filter-field-date/FilterFieldDate";

const TEXT_FIELD_TYPES = [FIELD_TYPES.TEXT, FIELD_TYPES.PHONE, FIELD_TYPES.URL, FIELD_TYPES.INT, FIELD_TYPES.MULTI_LANGUAGE_TEXT];
const LIST_FIELD_TYPES = [FIELD_TYPES.LIST, FIELD_TYPES.ACTION];
const MULTIPLE_SELECT_FIELD_TYPES = [FIELD_TYPES.CHOOSE_AT_LEAST_ONE, FIELD_TYPES.CHOOSE_ONE, FIELD_TYPES.COLLECTION_REF, FIELD_TYPES.BOOL];
const DATE_FIELD_TYPES = [FIELD_TYPES.DATE];

const FilterField = ({
  type,
  label,
  value,
  onChange,
  anchorEl,
  open,
  onClose,
  options,
  operator
}) => {
  const showTextField = TEXT_FIELD_TYPES.includes(type);
  const showListField = LIST_FIELD_TYPES.includes(type);
  const showMultipleSelectField = MULTIPLE_SELECT_FIELD_TYPES.includes(type);
  const showDateField = DATE_FIELD_TYPES.includes(type);

  return (
    <Popper
      open={Boolean(anchorEl && open)}
      anchorEl={anchorEl}
      placement="bottom-start"
      modifiers={[
        { name: "offset", options: { offset: [0, 4] } }
      ]}
    >
      <ClickAwayListener onClickAway={e => {
        if (e.target.tagName === "BODY") return;
        onClose();
      }}>
        <Paper
          data-testid={"filter-field"}
          elevation={3}
          sx={{
            boxShadow: theme => theme.shadows[3]
          }}
        >
          <PopperContent>
            {showTextField && <FilterFieldText
              label={label}
              value={value}
              onChange={onChange}
              onClose={onClose}
              operator={operator}
            />}

            {showListField && <FilterFieldList
              label={label}
              value={value}
              onChange={(newValue) => onChange({ value: newValue })}
              onClose={onClose}
            />}

            {showMultipleSelectField && <>
              <MultipleOptionsContent
                options={options}
                selectionOptions={value || []}
                testId={`filter-${label}`}
                onChange={(newValue) => onChange({ value: newValue })}
              />
            </>}

            {showDateField && <FilterFieldDate
              label={label}
              value={value}
              onChange={onChange}
              onClose={onClose}
            />}
          </PopperContent>
        </Paper>
      </ClickAwayListener>
    </Popper>
  );
};

const PopperContent = styled(Stack)(() => ({
  minWidth: "250px",
  maxWidth: "400px"
}));

export default FilterField;
